// extracted by mini-css-extract-plugin
export var redoItem = "_ir-1";
export var redoTrigger = "_ir-0";